// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__1kRpw","tab":"ProcedureTabs_tab__dvLC3"};